<div class="support-widget">
    <!-- Contenido principal con scroll -->
    <div class="support-widget__content" #contentContainer>
        <!-- Contenedor de mensajes (burbujas del chat) -->
        <div class="support-widget__messages" *ngIf="messages.length > 0">
            <div
                *ngFor="let msg of messages"
                class="support-widget__message"
                [class.user]="msg.role === 'user'"
            >
                <div class="support-widget__bubble" [class.user]="msg.role === 'user'">
                    {{ msg.content }}
                </div>
            </div>
        </div>

        <!-- FAQs -->
    <div *ngIf="showFAQs && !showTicketForm" class="support-widget__faqs">
        <div class="support-widget__faqs-header">
            <h4>{{ 'chat.support.faq.title' | translate }}</h4>
        </div>

        <div *ngIf="filteredFAQs.length > 0" class="support-widget__faq-list">
            <button
                *ngFor="let faq of filteredFAQs"
                class="support-widget__faq-item"
                (click)="clickFAQ(faq)"
            >
                <div class="faq-category">{{ faq.category }}</div>
                <div class="faq-question">{{ faq.question }}</div>
                <div class="faq-arrow">→</div>
            </button>
        </div>

        <div *ngIf="filteredFAQs.length === 0" class="support-widget__empty">
            <p>{{ 'chat.support.faq.empty' | translate }}</p>
        </div>
    </div>

    <!-- Formulario de Ticket -->
    <div *ngIf="showTicketForm" class="support-widget__ticket-form">
        <div class="form-field">
            <label for="ticket-subject">{{ 'chat.support.ticket.subject.label' | translate }} *</label>
            <input
                id="ticket-subject"
                [(ngModel)]="ticketSubject"
                type="text"
                [placeholder]="'chat.support.ticket.subject.placeholder' | translate"
                [disabled]="isLoading"
            />
        </div>

        <div class="form-field">
            <label for="ticket-email">{{ 'chat.support.ticket.email.label' | translate }}</label>
            <input
                id="ticket-email"
                [(ngModel)]="ticketEmail"
                type="email"
                [placeholder]="'chat.support.ticket.email.placeholder' | translate"
                [disabled]="isLoading"
            />
        </div>

        <div class="form-field">
            <label for="ticket-description">{{ 'chat.support.ticket.description.label' | translate }} *</label>
            <textarea
                id="ticket-description"
                [(ngModel)]="ticketDescription"
                [placeholder]="'chat.support.ticket.description.placeholder' | translate"
                rows="4"
                [disabled]="isLoading"
            ></textarea>
        </div>

        <div class="form-actions">
            <button
                class="form-btn form-btn--cancel"
                (click)="cancelTicket()"
                [disabled]="isLoading"
            >
                {{ 'chat.support.ticket.cancel' | translate }}
            </button>
            <button
                class="form-btn form-btn--submit"
                (click)="submitTicket()"
                [disabled]="
                    isLoading ||
                    !ticketSubject.trim() ||
                    !ticketDescription.trim()
                "
            >
                {{ isLoading ? ('chat.support.ticket.submitting' | translate) : ('chat.support.ticket.submit' | translate) }}
            </button>
        </div>
    </div>

        <!-- Opciones de seguimiento después de ver una FAQ -->
        <div
            *ngIf="!showFAQs && !showTicketForm && !ticketSubmitted"
            class="support-widget__follow-up"
        >
            <p class="support-widget__follow-up-text">{{ 'chat.support.helpful.question' | translate }}</p>
            <div class="support-widget__follow-up-buttons">
                <button
                    class="support-widget__follow-up-btn support-widget__follow-up-btn--yes"
                    (click)="markAsResolved()"
                >
                    ✓ {{ 'chat.support.helpful.yes' | translate }}
                </button>
                <button
                    class="support-widget__follow-up-btn support-widget__follow-up-btn--no"
                    (click)="backToFAQs()"
                >
                    ✗ {{ 'chat.support.helpful.no' | translate }}
                </button>
            </div>
        </div>

        <!-- Panel de ticket enviado con éxito -->
        <div *ngIf="ticketSubmitted" class="support-widget__success-panel">
            <div class="support-widget__success-icon">✓</div>
            <h4 class="support-widget__success-title">{{ 'chat.support.success.title' | translate }}</h4>
            <p class="support-widget__success-message">
                {{ 'chat.support.success.message' | translate }}
            </p>
            <div class="support-widget__ticket-info">
                <div class="ticket-info-item">
                    <span class="ticket-info-label">{{ 'chat.support.success.id-label' | translate }}</span>
                    <span class="ticket-info-value">{{ submittedTicketId }}</span>
                </div>
            </div>
            <p class="support-widget__success-note">
                {{ 'chat.support.success.note' | translate }}
            </p>
            <button class="support-widget__success-btn" (click)="backToFAQs()">
                {{ 'chat.support.back-to-faq' | translate }}
            </button>
        </div>
    </div>

    <!-- Input para búsqueda de soporte (fijo en la parte inferior) -->
    <div
        class="support-widget__input-section"
        *ngIf="showFAQs && !showTicketForm"
    >
        <input
            #userInput
            [(ngModel)]="userQuery"
            (keypress)="onKeyPress($event)"
            type="text"
            [placeholder]="'chat.support.faq.search.placeholder' | translate"
            class="support-widget__search-input"
            [disabled]="isLoading"
        />
        <button
            class="support-widget__search-btn"
            (click)="searchSupport()"
            [disabled]="!userQuery.trim() || isLoading"
        >
            {{ isLoading ? "⏳" : "🔍" }}
        </button>
    </div>
</div>
